import Quality from "../views/Quality/Quality";
import QualityCoatedDetail from "../views/Quality/QualityCoated";
import QualityCoatedData from "../views/Quality/QualityCoatedData";
import QualityCoatedAttachments from "../views/Quality/QualityCoatedAttachments";
import QualityCoatedPrint from "../views/Quality/QualityCoatedPrint";
import QualityRawDetail from "../views/Quality/QualityRaw";
import QualityRawData from "../views/Quality/QualityRawData";
import QualityRawAttachments from "../views/Quality/QualityRawAttachments";
import QualityRawPrinted from "../views/Quality/QualityRawPrinted";

export default [
  {
    path: "/Quality",
    component: Quality,
    name: "Quality"
  },
  {
    path: "/Quality/Coated/:id",
    component: QualityCoatedDetail,
    props: true,
    children: [
      {
        path: "Data",
        name: "QualityCoatedDetail",
        component: QualityCoatedData,
        props: true
      },
      {
        path: "Attachments",
        name: "QualityCoatedAttachments",
        component: QualityCoatedAttachments,
        props: true
      },
      {
        path: "Print",
        name: "QualityCoatedPrint",
        component: QualityCoatedPrint,
        props: true
      }
    ]
  },
  {
    path: "/Quality/Raw/:id",
    component: QualityRawDetail,
    props: true,
    children: [
      {
        path: "Data",
        name: "QualityRawDetail",
        component: QualityRawData,
        props: true
      },
      {
        path: "Attachments",
        name: "QualityRawAttachments",
        component: QualityRawAttachments,
        props: true
      },
      {
        path: "Print",
        name: "QualityRawPrint",
        component: QualityRawPrinted,
        props: true
      }
    ]
  },
]